export default "__VITE_ASSET__GwMDhXtj__"